import apiBase from './apiBase';

export default class mentorApi {
  static async toggleSchoolAttendenceAttended(id) {
    return await apiBase.patch(`/api/mentor_api/school_attendance/${id}/toggle_attended`, null);
  }

  static async saveProgressComment(id, progress_comment) {
    return await apiBase.post(`/api/mentor_api/school_attendance/${id}/progress_comment`, { progress_comment });
  }
}
